import { FieldView } from "shared/build/views"
import { getDateStringToDisplay } from "./field"

const formatPrice = (price: { amount: number, currency: string }) => `${price.amount ? price.amount / 100 : ''}${price.currency || ''}`
const formatDate = (timestamp: number) => Number(timestamp) && new Date(Number(timestamp)).getTime() ? getDateStringToDisplay(new Date(Number(timestamp))) : undefined

export const formatters: Record<Exclude<FieldView['format'], undefined>, (item: any) => string | undefined> = {
  price: formatPrice,
  date: formatDate,
}